import React, { useEffect, useState } from 'react';

export const WikiScrollTop = () => {
  const [visible, setVisible] = useState(() => window.scrollY > 300);
  useEffect(() => {
    const update = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', update, { passive: true });
    update();
    return () => window.removeEventListener('scroll', update);
  }, []);
  return visible ? <button type="button" className="wiki-scroll-top" aria-label="Scroll to top" onClick={() => {
    window.scrollTo({ top: 0, behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }}>↑</button> : null;
};
